exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu-box[data-v-19e7c2bb] {\n  margin-left: 50px;\n  height: 160px;\n}\n.step-mark1[data-v-19e7c2bb] {\n  margin-left: -30px;\n}\n.step-mark[data-v-19e7c2bb] {\n  margin-left: -35px; margin-top: 45px; position: absolute\n}\n.step-line[data-v-19e7c2bb] {\n  border-left: 3px solid rgba(0,0,0,.12);\n}\n.icon-col[data-v-19e7c2bb] {\n  min-width: 70px;\n}\n.title-bar[data-v-19e7c2bb] {\n  height: 44px;\n  color: white;\n  font-size: 22px;\n  font-weight: bold;\n  line-height: 44px;\n  padding: 0 0 0 12px;\n}\n", ""]);

// exports
